import { makeObservable, observable, action } from "mobx";

export default class ApiStore {
    params = '';

  constructor() {
    makeObservable(this, {
      params: observable,
      setParams:action
    })
  }

  setParams(val) {
    this.params = 'nihao'
  }

  
}